// extracted by mini-css-extract-plugin
module.exports = {"SmartWatch":"SmartWatchImg_SmartWatch__oM3Cr","SmartWatchScale":"SmartWatchImg_SmartWatchScale__2wpWk"};